import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'membership_referral';
export const route = 'membership_referral/[[...referralParams]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "membershipreferralconfirmationpage" */
'../../components/MembershipReferralConfirmationPage')));